module.exports = __webpack_public_path__ + "img/icon.e24e1c05.png";